import { render, staticRenderFns } from "./payment-options-bnpl.vue?vue&type=template&id=175f3a28&scoped=true&"
import script from "./payment-options-bnpl.vue?vue&type=script&lang=js&"
export * from "./payment-options-bnpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175f3a28",
  null
  
)

export default component.exports